import { url } from "@mozioinc/utils";
import { useQuery } from "@tanstack/react-query";
import posthog from "posthog-js";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Header as HeaderBase } from "../components";
import { useCurrency } from "../hooks";
import { currencyQuery } from "../utils/query";
import { getWhiteLabel } from "../utils/white-label";

const Header = () => {
  // cspell:disable
  const languages = [
    {
      name: "English",
      englishName: "English",
      locale: "en_US",
      href: url.setParam("locale", "en_US"),
    },
    {
      name: "Italiano",
      englishName: "Italian",
      locale: "it_IT",
      href: url.setParam("locale", "it_IT"),
    },
    {
      name: "Nederlands",
      englishName: "Dutch",
      locale: "nl",
      href: url.setParam("locale", "nl"),
    },
    {
      name: "Français",
      englishName: "French",
      locale: "fr",
      href: url.setParam("locale", "fr"),
    },
    {
      name: "Deutsch",
      englishName: "German",
      locale: "de_DE",
      href: url.setParam("locale", "de_DE"),
    },
    {
      name: "Norsk",
      englishName: "Norwegian",
      locale: "no_NO",
      href: url.setParam("locale", "no_NO"),
    },
    {
      name: "Dansk",
      englishName: "Danish",
      locale: "da_DK",
      href: url.setParam("locale", "da_DK"),
    },
    {
      name: "Suomi",
      englishName: "Finnish",
      locale: "fi_FI",
      href: url.setParam("locale", "fi_FI"),
    },
    {
      name: "Svenska",
      englishName: "Swedish",
      locale: "sv",
      href: url.setParam("locale", "sv"),
    },
  ];
  // cspell:enable

  const { header } = getWhiteLabel();
  const { i18n } = useTranslation();
  const { currency } = useCurrency();
  const [currencyMenuOpen, setCurrencyMenuOpen] = useState(false);
  const currenciesQuery = useQuery(
    ["currencies", currencyMenuOpen],
    currencyQuery.getCurrencies,
    { enabled: currencyMenuOpen },
  );

  const currencies =
    currenciesQuery.data?.map((c) => ({
      ...c,
      href: url.setParam("currency", c.code),
    })) || [];

  posthog.register({ displayed_locale: i18n.language });
  posthog.register({ displayed_currency: currency });

  return (
    <HeaderBase
      logo={{
        src: header.logo,
        alt: "Logo",
        href: "/",
      }}
      languageMenuProps={{
        languages: languages,
        locale: i18n.language,
      }}
      currencyMenuProps={{
        loading: currenciesQuery.isLoading,
        currencies,
        code: currency,
        onOpen: () => setCurrencyMenuOpen(true),
      }}
    />
  );
};

export { Header };
